module.exports = __webpack_public_path__ + "img/sara-lee-chromatic-jungle.e19b1b6.jpg";